import { motion } from 'framer-motion';
import { fadeUp, staggeredFadeIn } from '../../utils/animations';

const processSteps = [
    { num: '1', title: 'We enroll your VA on our monitoring platform', body: 'White Glove Hiring owns and pays for the monitoring account. Enrollment is included in your program fee at no extra cost. There is nothing for you to set up, buy, or manage.' },
    { num: '2', title: 'We review the data monthly', body: "Our team pulls the logs, reviews task categories, flags anomalies, and compiles findings. We do this every month for every VA we place. It's built into the program." },
    { num: '3', title: 'You get a written summary with recommendations', body: "You also get direct access to view your VA's timeclock records, activity data, and screenshot history at any time. Plain English. No fluff. Here's what happened, here's what we noticed, here's what we suggest. If a conversation with your VA is needed, we'll tell you exactly what to cover." },
];

export function OversightProcess() {
    return (
        <section className="bg-[#F8F9FA] py-24 md:py-32" data-testid="how-it-works">
            <div className="max-w-3xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="mb-14">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight">
                        The Process Is Simple. The Impact Isn't.
                    </h2>
                </motion.div>

                <div className="space-y-0">
                    {processSteps.map((step, i) => (
                        <motion.div
                            key={step.num}
                            {...staggeredFadeIn(i * 0.1)}
                            className="relative pl-16 pb-12 last:pb-0"
                            data-testid={`process-step-${step.num}`}
                        >
                            {i < processSteps.length - 1 && (
                                <div className="absolute left-[19px] top-10 w-px h-[calc(100%-24px)] bg-gray-300" />
                            )}
                            <div className="absolute left-0 top-0 w-10 h-10 rounded-full bg-navy-900 flex items-center justify-center">
                                <span className="text-gold-400 text-sm font-bold font-inter">{step.num}</span>
                            </div>
                            <h3 className="font-montserrat font-bold text-lg text-navy-900 mb-2 pt-1.5">{step.title}</h3>
                            <p className="text-[#6B7280] text-sm leading-relaxed">{step.body}</p>
                        </motion.div>
                    ))}
                </div>

                <motion.div {...fadeUp} className="mt-10 rounded-sm overflow-hidden border border-gray-200 shadow-md" data-testid="screenshot-3">
                    <img
                        src="https://customer-assets.emergentagent.com/job_01a94bc3-1239-473e-9729-85c2afc85aa9/artifacts/y4dmskn4_image.png"
                        alt="ScreenshotMonitoring.com - Daily dashboard showing work hours, calendar view, and hourly activity timeline"
                        className="w-full h-auto"
                    />
                </motion.div>
            </div>
        </section>
    );
}
